import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close-modal",
  "use": "icon-close-modal-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" fill=\"none\" id=\"icon-close-modal\"><circle cx=\"16\" cy=\"16\" r=\"14\" fill=\"#D9DBE9\" /><path d=\"M10 10L22.7742 22.7742\" stroke=\"#6E7191\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path d=\"M10 22.7742L22.7742 10\" stroke=\"#6E7191\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol